// extracted by mini-css-extract-plugin
module.exports = {"imgContainer":"index_imgContainer__KYWoH"};